import { useState, useEffect, useRef } from "react";
import {
  getOrganigramaCFE,
  buscarContactosCFE,
  crearContactoCFE,
  actualizarContactoCFE,
  generarExcelContactosCFE,
  eliminarContactoCFE,
} from "../../components/functions/Soporte";
import OrganigramaCFE from "./modals/OrganigramaCFE";
import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsSoporte } from "../../constants/soporte";
import {
  Button,
  Menu,
  MenuItem,
  Snackbar,
  ClickAwayListener,
  Popper,
} from "@mui/material";
import SubirG from "../../assets/img/svg/providers/CargarVerde.svg";
import DescargarG from "../../assets/img/svg/users/descargarGreen.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import EditarA from "../../assets/img/svg/users/editar.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import { headCellCenterAlign } from "../../utils/columnStyles";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import Anadir from "../../assets/img/svg/anadir.svg";
import CustomButton from "../../ui/button/Button";
import NuevoContactoCFE from "./modals/NuevoContactoCFE";
import LoaderDialog from "../../ui/loader/Loader";

const DirectorioCFE = ({ API_URL }) => {
  const [data, setData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [tableInstance, setTableInstance] = useState(null);
  const [selectedTreeNode, setSelectedTreeNode] = useState(null);

  const [openNuevoContacto, setOpenNuevoContacto] = useState(false);
  const [selectedContacto, setSelectedContacto] = useState(null);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [showLoader, setShowLoader] = useState(false);

  const showDialog = useConfirmDialog();

  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getOrganigramaCFE(API_URL);
        setData(result);
      } catch (error) {
        console.error("Error fetching organigrama CFE:", error);
      }
    };

    fetchData();
  }, []);

  const handleItemClick = async (node) => {
    try {
      setSelectedTreeNode(node);
      const res = await buscarContactosCFE(API_URL, node);
      setTableData(res);
    } catch (error) {}
  };

  const handleCreateContacto = async (data) => {
    try {
      setShowLoader(true);
      setOpenNuevoContacto(false);
      const payload = {
        ...data,
        organigramaCFE: selectedTreeNode,
      };
      if (selectedContacto) {
        await actualizarContactoCFE(API_URL, payload);
        setSelectedContacto(null);
      } else {
        await crearContactoCFE(API_URL, payload);
      }

      const res = await buscarContactosCFE(API_URL, selectedTreeNode);
      setTableData(res);
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarMessage("Ocurrió un error al guardar el contacto");
    } finally {
      setShowLoader(false);
    }
  };

  const columns = [
    {
      accessorKey: "nombre",
      header: "Nombre",
      accessorFn: (row) => `${row.nombre || ""} ${row.apellido || ""}`,
    },

    {
      accessorKey: "email",
      header: "Correo",
    },
    {
      accessorKey: "telefono",
      header: "Número telefónico",
    },
    {
      accessorKey: "extension",
      header: "Ext.",
    },
    {
      accessorKey: "celular",
      header: "Celular",
    },
    {
      accessorKey: "tipoCargo.descripcion",
      header: "Posición",
    },
    {
      accessorKey: "direccion",
      header: "Dirección",
    },
    {
      accessorKey: "comentarios",
      header: "Comentarios",
    },
    {
      id: "submenu",
      header: " ",
      size: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => {
        const rowData = row.original;
        const anchorRef = useRef(null);
        const isOpen = openMenuIndex === row.index;

        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={anchorRef}
              onClick={() =>
                setOpenMenuIndex((prevIndex) =>
                  prevIndex === row.index ? null : row.index
                )
              }
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <Popper
              open={isOpen}
              anchorEl={anchorRef.current}
              placement="bottom-start"
              style={{ zIndex: 9999 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    marginTop: "5px",
                    padding: "5px",
                    minWidth: "80px",
                  }}
                >
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setSelectedContacto(row.original);
                      setOpenNuevoContacto(true);
                      setOpenMenuIndex(null);
                    }}
                  >
                    <img
                      src={EditarA}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Editar
                  </p>
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      showDialog({
                        icon: "warning",
                        html: `¿Estas seguro de eliminar el contacto ${
                          rowData.nombre || ""
                        } ${rowData.apellido || ""}?`,
                        confirmButtonText: "Eliminar",
                        mostrarCancelar: true,
                        onConfirm: async () => {
                          try {
                            await eliminarContactoCFE(API_URL, rowData.id);
                            const res = await buscarContactosCFE(
                              API_URL,
                              selectedTreeNode
                            );
                            setTableData(res);
                          } catch (error) {}
                        },
                      });
                    }}
                  >
                    <img
                      src={Eliminar}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Eliminar
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const table = useMaterialReactTable({
    columns,
    data: tableData,
    enableSorting: true,
    enableFilters: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    defaultColumn: {
      minSize: 40,
      size: 80,
    },
  });

  return (
    <div className="mi-container" style={{ display: "flex", width: "100%" }}>
      <div className="mi-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsSoporte} />
      </div>

      <div
        className="mi-main"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
        }}
      >
        <div
          className="pgp-controls"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <h1 className="map-title" style={{ margin: 0 }}>
            Directorio CFE
          </h1>

          <Button
            onClick={handleClick}
            className="custom-button-menu-cc"
            endIcon={<KeyboardArrowDownIcon />}
          >
            Subir y Descargar
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              list: {
                "aria-labelledby": "basic-button",
              },
            }}
          >
            <MenuItem className="menu-item-text" onClick={() => {}}>
              <img
                src={SubirG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              Subir Excel para editar
            </MenuItem>
            <MenuItem
              className="menu-item-text"
              onClick={async () => {
                setShowLoader(true);
                try {
                  const blob = await generarExcelContactosCFE(API_URL, {});
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `Contactos_CFE.xls`;
                  a.rel = "noopener";
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  setTimeout(() => URL.revokeObjectURL(url), 1000);
                } catch (error) {}
                setShowLoader(false);
              }}
            >
              <img
                src={DescargarG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              Descargar Excel
            </MenuItem>
          </Menu>
        </div>

        {data && <OrganigramaCFE data={data} onItemClick={handleItemClick} />}

        {selectedTreeNode && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              margin: "0 0 10px",
            }}
          >
            <h2 style={{ margin: "10px 0" }}>
              {selectedTreeNode.nombreDepartamento} (
              {tableData ? tableData.length : "0"})
            </h2>
            <CustomButton
              background="#223D51"
              width="185px"
              height="28px"
              fontSize="14px"
              color="#FFFFFF"
              text="Registrar contacto CFE"
              fontWeight={700}
              fontStyle="normal"
              border={0}
              icon={true}
              src={Anadir}
              iconW="12px"
              iconM="5px"
              onClick={() => {
                setSelectedContacto(null);
                setOpenNuevoContacto(true);
              }}
            />
          </div>
        )}
        {data && (
          <MaterialReactTable
            table={table}
            onTableReady={(table) => setTableInstance(table)}
          />
        )}
      </div>

      <NuevoContactoCFE
        open={openNuevoContacto}
        onClose={() => {
          setOpenNuevoContacto(false);
          setSelectedContacto(null);
        }}
        onConfirm={handleCreateContacto}
        API_URL={API_URL}
        contacto={selectedContacto}
      />

      <LoaderDialog open={showLoader} />

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
    </div>
  );
};

export default DirectorioCFE;
